export const path = (url = '') => {
    const basename = '/';
    return basename + url;
};
